import React, { useState, useEffect, Fragment } from 'react';
import { Row, Modal, ModalHeader, ModalBody, Button, Collapse, CustomInput, Card, CardTitle, CardBody } from 'reactstrap';
import styled from "styled-components";
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RotateSpinner } from 'react-spinners-kit';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
    putAPI_Update_Response,
    gAPI_PropertiesBotResponseByCode
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import HeroCardResponse from './HeroCardResponse';
import ExampleResponse from './ExampleResponse';
import MessageResponse from './MessageResponse';
import LinkResponse from './LinkResponse';
import VideoResponse from './VideoResponse';
import ImageCarouselResponse from './ImageCarouselResponse';

const ModelDiv = styled.div`
    border-bottom: 1px solid #d7d7d7;
    padding: 0rem 0rem 1rem 0rem;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    .close-model{
        padding: 1rem 1rem;
        margin: -1rem -1rem -1rem auto;
        background-color: transparent;
        border: 0;
        float: right;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
    }`;

const GenerateResponseBlock = ({ elem, reloadBotResponse }) => {
    switch (elem.response.type) {
        case 'example':
            return (
                <ExampleResponse
                    child={1}
                    elem={{ ...elem }}
                    viewResponse={true}
                    reloadBotResponse={reloadBotResponse}
                />
            );

        case 'messages':
            return (
                <MessageResponse
                    child={1}
                    elem={{ ...elem }}
                    viewResponse={true}
                    reloadBotResponse={reloadBotResponse}
                />);

        case 'messages-link':
            return (
                <Fragment>
                    <LinkResponse
                        child={1}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}></LinkResponse>
                </Fragment>
            );

        case 'messages-image-carousel':
            return (
                <Fragment>
                    <ImageCarouselResponse
                        child={1}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}
                    />
                </Fragment>
            );
        case 'messages-video':
            return (
                <Fragment>
                    <VideoResponse
                        child={1}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}
                    />
                </Fragment>
            );
        case 'herocard':
            return (
                <Fragment>
                    <HeroCardResponse
                        child={1}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}
                    />
                </Fragment>
            );
        default:
            break;
    }
}

function ResponseReplicationPop({ propertyId, locale, code, reloadBotResponse, showFav, visible, toggle, propertyList, selectedLang }) {
    //console.log(propertyList);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [properties, setProperties] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedProperties, setSelectedProperties] = useState([]);
    const [postData, setPostData] = useState({
        GroupId: getGroupID(),
        Code: code,
        Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
        Channel: 'WebsiteDirectLine',
        PropertyId: propertyId === "-1" ? null : propertyId,
        Properties: []
    });
    const [propertyResponseData, setPropertyResponse] = useState([]);

    useEffect(() => {
        let propertyId = [];
        const languageList = propertyList.map((elem) => {
            propertyId.push(elem.id);
            elem.checked = false;
            selectedProperties.forEach((lang) => {
                if (lang.id === elem.id) {
                    elem.checked = true;
                }
            });
            return elem;
        });
        setProperties(languageList);

        let body = {
            properties: propertyId
        }
        AxiosAPI({
            method: 'post',
            url: `${gAPI_PropertiesBotResponseByCode}/?group_id=${getGroupID()}&lang=${selectedLang === 'en' ? 'en-US' : selectedLang
                }&code=${code}`,
            data: body
        }).then((res) => {
            setPropertyResponse(res.data);
            setIsLoading(false);
        }).catch((err) => {
            console.log(err);
        });
    }, [propertyList]);

    const handleAllChecked = (e) => {
        const list = properties.map((elem) => {
            if (e.target.checked) { elem.checked = true; }
            else { elem.checked = false; }
            return elem;
        });
        setProperties(list);

        setCheckedAll(e.target.checked);
    };
    const handleChecked = (e) => {
        const list = properties.map((elem) => {
            if (elem.id === e.target.value) {
                elem.checked = e.target.checked;
            }
            return elem;
        });
        setProperties(list);
        if (properties.filter((i) => i.checked === true).length === properties.length) {
            setCheckedAll(true);
        } else {
            setCheckedAll(false);
        }
        var property = list.filter(i => i.checked === true).map(elem => elem.id);
        setSelectedProperties(property);
        setPostData(pre => {
            return { ...pre, Properties: property };
        });
    };
    const handleSave = async () => {
        try {
            return await AxiosAPI({
                method: 'put',
                url: putAPI_Update_Response + "/by-property",
                data: postData,
            })
                .then((res) => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        toggle();
                        NotificationManager.success(
                            "",
                            "All response has been replicated across the selected properties.",
                            3000,
                            null,
                            null,
                            "success"
                        );
                        setTimeout(() => {
                            reloadBotResponse();
                        }, 1000)
                    }
                })
                .finally(

            );
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Fragment>
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
                                <ModalBody>
                                    <ModelDiv>
                                        <Row>
                                            <Colxx xxs="6">
                                                <h5>Copy Response to Other Properties</h5>
                                                <CustomInput
                                                    type="checkbox"
                                                    id="is_globel"
                                                    label="Select All"
                                                    checked={checkedAll}
                                                    onChange={handleAllChecked}
                                                />
                                            </Colxx>
                                            <Colxx xxs="6">
                                                <div className='float-right mt-4'>
                                                    {postData.Properties.length > 0 ?
                                                        <Button
                                                            color="secondary"
                                                            className="add-button"
                                                            size="xs"
                                                            style={{ width: "max-content" }}
                                                            onClick={handleSave}
                                                        >
                                                            Update Selected
                                                        </Button> :
                                                        <Button
                                                            color="secondary"
                                                            className="add-button"
                                                            size="xs"
                                                            style={{ width: "max-content" }}
                                                            disabled
                                                        >
                                                            Update Selected
                                                        </Button>
                                                    }
                                                    <button onClick={() => toggle()} type='button' className='close close-model'>
                                                        <span>x</span>
                                                    </button>
                                                </div>
                                            </Colxx>
                                        </Row>
                                    </ModelDiv>
                                    <div style={{ overflowY: "scroll", maxHeight: "40rem", display: "flex" }}>
                                        <div className='mt-2' style={{ width: "98%" }}>
                                            {properties !== undefined && properties.length > 0 &&
                                                properties.map((pro, i) => (
                                                    <Card key={i}>
                                                        <CardBody className="mt-0" style={{ marginLeft: "-15px" }}>
                                                            <Row>
                                                                <Colxx xxs="12" xs="3" className="">
                                                                    <CustomInput
                                                                        type="checkbox"
                                                                        id={"property_" + i}
                                                                        label={pro.name}
                                                                        value={pro.id}
                                                                        checked={pro.checked}
                                                                        onChange={(e) => handleChecked(e)}
                                                                    />
                                                                </Colxx>
                                                                <Colxx xxs="12" xs="9">
                                                                    {isLoading ?
                                                                        <Row>
                                                                            <Colxx xxs="5" className="mb-2"></Colxx>
                                                                            <Colxx xxs="2" className="mb-2">
                                                                                <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
                                                                            </Colxx>
                                                                            <Colxx xxs="5" className="mb-2"></Colxx>
                                                                        </Row> :
                                                                        propertyResponseData.length > 0 &&
                                                                        propertyResponseData.filter(p => p.propertyId === pro.id).map((item, i) => {
                                                                            return <GenerateResponseBlock
                                                                                key={i}
                                                                                elem={item.response[0]}
                                                                                reloadBotResponse={reloadBotResponse}
                                                                            ></GenerateResponseBlock>
                                                                        })
                                                                    }
                                                                </Colxx>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                ))}
                                        </div>
                                    </div>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(ResponseReplicationPop));